import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import EasySlider from "vue-easy-slider";
import './untils/createRichTextDirective';

Vue.use(EasySlider);
Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.use(ElementUI);

store.dispatch('fetchResources') // 在应用创建前获取静态资源
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
